import {EnvelopeNewIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {Rating} from 'shells/rating/rating';
import {Body} from 'shells/typography/body';

import type {WidgetFragment} from 'nutshell-graphql-types';

import {CollapsibleCardWidget} from '../../../core/card/collapsible-card-widget';
import {useGetPeepEngagementStats} from '../../../entity-details/graphql/hooks/use-get-peep-engagement-stats';

import {PeepEmailStats} from './peep-email-stats';

interface Props {
    peepId: string;
    widget: WidgetFragment;
}

export function EmailEngagementWidget(props: Props) {
    const {peep, isLoading, error} = useGetPeepEngagementStats(props.peepId);

    const isEmpty =
        peep &&
        peep.engagementStats.totalSentCount === 0 &&
        peep.engagementStats.openRate === null &&
        peep.engagementStats.clickRate === null &&
        peep.engagementStats.replyRate === null;

    return (
        <CollapsibleCardWidget
            widget={props.widget}
            isLoading={isLoading}
            emptyStateProps={{
                isEmpty: Boolean(isEmpty),
                text: 'No email activity available',
                icon: EnvelopeNewIcon,
                iconSize: 20,
            }}
            errorProps={{
                error: error,
                setError: () => {},
            }}
            secondaryTitle={
                props.widget.isCollapsedForUser &&
                !isLoading &&
                peep &&
                !isEmpty && <Rating score={peep.engagementRating} />
            }
        >
            {peep && (
                <div className='flex px-16 pb-4 flex-dir-col gap-8'>
                    <Stack spacing={8} isHorizontal justifyContent='space-between' isFullWidth>
                        <Body size='small' color='light'>
                            Personal and marketing emails
                        </Body>
                        <Rating score={peep.engagementRating} />
                    </Stack>
                    <PeepEmailStats
                        totalSentCount={peep.engagementStats.totalSentCount}
                        openRate={peep.engagementStats.openRate}
                        clickRate={peep.engagementStats.clickRate}
                        replyRate={peep.engagementStats.replyRate}
                    />
                </div>
            )}
        </CollapsibleCardWidget>
    );
}
